import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconCheck,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import type { FavoriteMarketsOrder } from 'shared/src/api/favoriteMarketService/getFavoriteMarketsFilterOptions/types';

interface MarketSortBottomSheetParam {
  orders: FavoriteMarketsOrder[];
  selectedKey: string;
}

export const useMarketSortBottomSheet = createUseBottomSheetModal<
  { selected: FavoriteMarketsOrder },
  MarketSortBottomSheetParam
>(({ confirm, param }) => {
  return (
    <BottomSheetContainer>
      <VerticalSpacing size={16} />
      {param.orders.map(order => {
        const isSelected = order.key === param.selectedKey;
        return (
          <Flex
            horizontal
            key={order.key}
            alignItems={'center'}
            justifyContent={'space-between'}
            padding={{ horizontal: 16, vertical: 16 }}
            onPress={() => confirm({ selected: order })}
          >
            <Typography
              type={isSelected ? 'subtitle1' : 'body1'}
              color={isSelected ? 'content_pink_primary' : undefined}
            >
              {order.name}
            </Typography>
            {isSelected && (
              <IconCheck size={20} fill={Colors.content_pink_primary} />
            )}
          </Flex>
        );
      })}
    </BottomSheetContainer>
  );
});
